import {createActionsFromActionTypes} from 'utils'
import actionTypes from 'actionTypes'

export default createActionsFromActionTypes(actionTypes)
